module.exports = __webpack_public_path__ + "img/wxk.ec3ecb02.jpg";